import React, { useRef } from 'react';
import styled from 'App/styled';
import SizeMini from '@nykaa/variant-selector/Sizes/SizeMini';
import { Variant } from 'shared/store/product/types';
import SizeHeader from '@nykaa/variant-selector/components/SizeHeader';

interface VariantListProps {
  variants: Variant[];
  changeVariant: Function;
  selectedProductId: string;
  isMiniEnabled?: boolean;
}

const Wrapper = styled.div``;

const ListWrapperV1 = styled.ul`
  overflow: hidden;
  list-style-type: none;
  margin: 15px;
  padding: 15px;
  text-align: center;
`;

const ListWrapperV2 = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: ${({ theme }) => `${theme.spacing.spacing0}`};
  margin-left: ${({ theme }) => theme.spacing.spacing40};
`;

const Item = styled.li`
  display: inline-block;
  margin: 4px 5px;
  vertical-align: top;
  text-align: center;
  &.oos {
    opacity: 0.5;
  }
`;

const Label = styled.label`
  display: flex;
  &.active {
    background: #3f414d;
    font-weight: 500;
    color: #fff;
  }
  &.oos {
    position: relative;
    &:after {
      content: '';
      display: inline-block;
      position: absolute;
      width: 1px;
      height: 44px;
      transform: rotate(-45deg);
      background-color: rgba(255, 255, 255, 0.7);
      top: -6px;
      left: 50%;
      z-index: 1;
    }
  }
`;

const PackSize = styled.span`
  border: 1px solid ${(props) => props.theme.brandPrimaryRgba(0.92)};
  padding: 10px;
  display: block;
`;

const SizeWrapper = styled.div`
  margin-left: ${({ theme }) => theme.spacing.spacing80};
`;

const VariantList = ({
  variants,
  selectedProductId,
  changeVariant,
  isMiniEnabled,
}: VariantListProps) => {
  const wrapperRef = useRef(null);
  const ListWrapper = isMiniEnabled ? ListWrapperV2 : ListWrapperV1;
  return (
    <Wrapper>
      {isMiniEnabled && (
        <SizeWrapper>
          <SizeHeader variantCount={variants.length} />
        </SizeWrapper>
      )}
      <ListWrapper role="radiogroup">
        {variants.map((variant, index) => {
          const { childId, quantity, variantName } = variant;
          const isVariantSelected = childId === selectedProductId;
          const isVariantOutOfStock = quantity === 0;
          let additionalClass = isVariantSelected ? 'active' : '';

          if (isVariantOutOfStock) {
            additionalClass += ' oos';
          }
          return (
            <>
              {isMiniEnabled ? (
                <SizeMini
                  variant={variant}
                  isSelected={isVariantSelected}
                  isOutOfStock={isVariantOutOfStock}
                  onClick={() => changeVariant(childId)}
                  wrapperRef={wrapperRef}
                  platform={__PLATFORM__}
                />
              ) : (
                <Item
                  className={additionalClass}
                  key={`allshadeLi-${index}`}
                  onClick={() => changeVariant(childId)}
                  role="radio"
                  aria-checked={isVariantSelected}
                >
                  <Label className={additionalClass}>
                    <PackSize>{variantName}</PackSize>
                  </Label>
                </Item>
              )}
            </>
          );
        })}
      </ListWrapper>
    </Wrapper>
  );
};

export default VariantList;
